import { request } from './api';
import { IRegion } from './regions.api';

export interface ICity {
  id: number;
  name: string;
  region: IRegion;
}

export interface ICreateCity {
  name: string;
  region: string;
}

export function getCities() {
  return request<ICity[]>('get', 'cities');
}

export function createCity(city: ICreateCity) {
  return request<ICity>('post', 'cities', { city });
}

export function updateCity(id: number, city: ICreateCity) {
  return request<ICity>('patch', `cities/${id}`, { city });
}

export function deleteCity(id: number) {
  return request('delete', `cities/${id}`);
}



// WEBPACK FOOTER //
// ./src/api/v2/cities.api.ts